export default __webpack_public_path__ + "2026 Hybrid Atomistic-Parametric Decoherence Model for Molecular Spin Qubits.pdf";